import { render, staticRenderFns } from "./ClassRecord.vue?vue&type=template&id=71fc4300&scoped=true&"
import script from "./ClassRecord.vue?vue&type=script&lang=js&"
export * from "./ClassRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClassRecord.vue?vue&type=style&index=0&id=71fc4300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc4300",
  null
  
)

export default component.exports